import React from "react";
import { Row, Col, Input, Label } from "reactstrap";
import FormStepHeader from "../../../../components/Common/FormStepHeader";
import FormColumn from "../../../../components/Common/FormColumn";
import RiskMatrix from "components/Common/RiskMatrix";
export default ({ booking, riskTemplate, onUpdateValue, currentStep, index }) => {


  const setListValue = (list, name, value, key = 'value') => {

    if (!booking.risks) {
      const newValue = { id: riskTemplate.id, name: riskTemplate.name };
      newValue[list] = [{ name, [key]: value }]
      onUpdateValue(riskTemplate, newValue);
      return;
    }

    const currentRiskIndex = booking.risks.findIndex(x => x.id === riskTemplate.id);
    if (currentRiskIndex > -1) {
      const currentRisk = booking.risks[currentRiskIndex];

      if (currentRisk[list] == null) {
        currentRisk[list] = [{ name, [key]: value }]
        onUpdateValue(riskTemplate, currentRisk);
      }

      const currentHazardIndex = currentRisk[list].findIndex(x => x.name === name);
      if (currentHazardIndex > -1) {
        currentRisk[list][currentHazardIndex][key] = value;
      } else {
        currentRisk[list].push({ name, [key]: value });
      }

      onUpdateValue(riskTemplate, currentRisk);
    } else {
      const newValue = { id: riskTemplate.id, name: riskTemplate.name };
      newValue[list] = [{ name, [key]: value }]
      onUpdateValue(riskTemplate, newValue);
    }
  }
  const toTitleCase = (str) => {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  const getListValue = (list, name, key = 'value') => {
    if (!booking.risks) return null;

    const currentRiskIndex = booking.risks.findIndex(x => x.id === riskTemplate.id);

    if (currentRiskIndex < 0) return null;

    const currentRisk = booking.risks[currentRiskIndex];

    if (currentRisk[list] == null) return null;


    var currentHazardIndex = currentRisk[list].findIndex(x => x.name === name);
    if (currentHazardIndex < 0) return null;

    return currentRisk[list][currentHazardIndex][key];
  }


  const renderHazards = () => {

    const hazardArray = riskTemplate.hazards.map((hazard) => (
      <Row className="d-flex align-items-center mb-2" key={hazard.id}>
        <Col xs={12} md={8}>
          {hazard.name}
        </Col>

        <Col xs={12} md={4}>
          <Input type="select" name="select" id="exampleSelect" bsSize={`sm`} value={getListValue('hazards', hazard.name) || ''} onChange={(e) => setListValue('hazards', hazard.name, e.target.value)}>
            <option>None</option>
            <option>Low</option>
            <option>Medium</option>
            <option>High</option>
            <option>Extreme</option>
          </Input>
        </Col>
      </Row>
    ));

    hazardArray.push(<Row className="d-flex align-items-center mb-2" key={"Other"}>
      <Col xs={12} md={8}>
        Other
      </Col>

      <Col xs={12} md={4}>
        <Input type="text" bsSize={`sm`} value={getListValue('hazards', "Other") || ''} onChange={(e) => setListValue('hazards', "Other", e.target.value)}>

        </Input>
      </Col>
    </Row>);

    return hazardArray;
  };




  return (<>
    <div className="mb-5">
      <h3>{`${toTitleCase(riskTemplate.name)} Risks`}</h3>
      <Row>
        <Col>
          <label className="text-uppercase ls-1 mb-0 h6">Hazards Identified</label>
        </Col>
      </Row>
      {renderHazards()}

      <Row>
        <Col>
          <hr className={`my-2 p-0`} />
        </Col>
      </Row>
    </div></>
  );
};
